import React from "react";
import CustomTable from "../../ui/DataTable";
import Pagination from "../../ui/Pagination";
import OfferActions from "./OfferActions";
import { useSelector } from "react-redux";
import { selectCid } from "../../../features/companyid";
import useFetch from "../../../hooks/useFetch";
import { selectCustomPagination } from "../../../features/paginationStore";

const columns = [
  {
    key: "sno",
    header: "S.No",
    body: (row) => {
      return <div className="w-fit ml-2">{row.sno}</div>;
    },
    width: "5%",
    notCentered: true,
  },
  {
    key: "name",
    header: "Name",
    body: (row) => {
      return <div className="w-fit min-w-1/4 ml-2">{row.name}</div>;
    },
    notCentered: true,
    width: "25%",
  },
  {
    key: "description",
    header: "Description",
    body: (row) => {
      return (
        <div className="w-fit min-w-1/4 max-w-[400px] break-all ml-2 text-start">
          {row.description}
        </div>
      );
    },
    width: "25%",
    notCentered: true,
  },
  {
    key: "mapped_salary_name",
    header: "Salary linked",
    body: (row) => {
      return row.mapped_salary_name
 ? ( <div className="max-w-[400px]">{row.mapped_salary_name}</div>
      ) : (
        <div className="text-red-500">Not Linked</div>
      );
    },
    width: "15%",
  },
  {
    key: "action",
    header: "Actions",
    body: (row) => {
      return <OfferActions id={row.uuid} />;
    },
    width: "15%",
  },
];

const OfferTemplate = () => {
  const cid = useSelector(selectCid);

  const { data = {}, isLoading } = useFetch(
    "/v2/template/getall/" + cid + "?type=offer"
  );

  const { page, page_size } = useSelector((state) =>
    selectCustomPagination(state, "offerTemplate")
  );

  const totalPage = Math.ceil((data?.count || 0) / page_size);

  const finalData = [...(data.templates || [])].sort((a, b) => a.name.localeCompare(b.name))
    ?.map((row, index) => {
      return {
        ...row,
        sno: index + 1,
      };
    })
    .slice((page - 1) * page_size, page * page_size);

  return (
    <>
    <div className="rounded-xl bg-white border border-gray-200 overflow-hidden">
      <CustomTable
        columns={columns}
        tableData={finalData || []}
        laoding={isLoading}
        className="!px-0 rounded-xl"
        tableClass="!my-0 !border-t-0"
        noBorder
      />

      <div className="w-full pt-[1px] mb-4 bg-gray-200" />

      <Pagination
        totalPages={totalPage}
        page={page}
        pageKey={"offerTemplate"}
      />
    </div>
    </>
  );
};

export default OfferTemplate;
